export default function timezoneShift(date: Date) {
    date = new Date(date)
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset())
    return date
}